import CryptoJS from "crypto-js";
import moment from "moment";
import * as Strings from "../commons/string";
import * as Types from "../commons/typeDTO";

import { AlertType } from "../provider/AlertProvider";
import { SortOrder } from "antd/es/table/interface";
import { Modal } from "antd";

const secretPass = "RUTA40";
export const getLocalStorage = (key: string) => {
    const item = localStorage.getItem(key);
    if (item === undefined || item === null) return item;

    const decrypted = CryptoJS.AES.decrypt(item, secretPass);

    try {
        const converted = decrypted.toString(CryptoJS.enc.Utf8);
        return converted;
    } catch (error) {
        removeLocalStorage(key);
        return undefined;
    }
};

export const setLocalStorage = (key: string, value: string) => {
    const encryped = CryptoJS.AES.encrypt(value, secretPass).toString();
    return localStorage.setItem(key, encryped);
};

export const removeLocalStorage = (key: string) => {
    return localStorage.removeItem(key);
};

export const utcToLocalTime = (utcTime: string, format: string) => {
    const localTime = moment.utc(utcTime).toDate();
    return moment(localTime).format(format);
};

export const localTimeToUtc = (localTime: string, format: string) => {
    const utcTime = moment(localTime).subtract(9, "hour");
    return moment(utcTime).format(format);
};

export const checkUnAuthorizedToken = (error: any | null) => {
    if (error === null) return false;

    if (error.response?.data?.code === AlertType.UNAUTHORIZED && error.response?.data?.message === "Unauthorized token") {
        return true;
    }

    return false;
};

export const sortDate = (a: string, b: string, sortOrder?: SortOrder): number => {
    if (a != null && b != null) {
        return moment(a).unix() - moment(b).unix();
    }
    if (a) {
        return sortOrder === "ascend" ? -1 : 1;
    }
    if (b) {
        return sortOrder === "ascend" ? 1 : -1;
    }
    return 0;
};

export const sortNumber = (a: number, b: number, sortOrder?: SortOrder): number => {
    if (a != null && b != null) {
        return a - b;
    }
    if (a) {
        return sortOrder === "ascend" ? -1 : 1;
    }
    if (b) {
        return sortOrder === "ascend" ? 1 : -1;
    }
    return 0;
};

export const sortString = (a: string, b: string, sortOrder?: SortOrder): number => {
    if (a != null && b != null) {
        return a.localeCompare(b);
    }
    if (a) {
        return sortOrder === "ascend" ? -1 : 1;
    }
    if (b) {
        return sortOrder === "ascend" ? 1 : -1;
    }
    return 0;
};

export const sortBoolean = (a: boolean, b: boolean, sortOrder?: SortOrder): number => {
    if (a != null && b != null) {
        return a.toString().localeCompare(b.toString());
    }
    if (a) {
        return sortOrder === "ascend" ? -1 : 1;
    }
    if (b) {
        return sortOrder === "ascend" ? 1 : -1;
    }
    return 0;
};
export const convertUserType = (userType: string) => {
    if (userType === "INDIVIDUAL") {
        return "개인";
    } else if (userType === "CORPORATE") {
        return "법인";
    }

    return "";
};

export const convertAuthority = (authority: string) => {
    let returnAuthority = "";

    switch (authority) {
        case "ROLE_ADMIN":
            returnAuthority = "최고운영자";
            break;

        case "ROLE_MANAGER":
            returnAuthority = "통합관리자";
            break;

        case "ROLE_RENT_MANAGER":
            returnAuthority = "렌트관리자";
            break;

        case "ROLE_B2B_MANAGER":
            returnAuthority = "B2B관리자";
            break;

        case "ROLE_USER":
            returnAuthority = "사용자";
            break;

        default:
            break;
    }

    return returnAuthority;
};

export const convertCurrencyKorean = (price: number) => {
    const convert = new Intl.NumberFormat("ko-KR").format(price) + "원";
    return convert;
};

export const convertPaymentType = (paymentType: string | undefined) => {
    let type = "";

    switch (paymentType) {
        case "DEPOSIT":
            type = Strings.paymentDeposit;
            break;
        case "DOWN_PAYMENT":
            type = Strings.paymentDownPayment;
            break;
        case "SUBSIDY":
            type = Strings.paymentSubsiby;
            break;
        case "BALANCE":
            type = Strings.paymentBalance;
            break;
        case "ADDITIONAL_DOWN_PAYMENT":
            type = Strings.paymentAdditionalDownPayment;
            break;
        case "ADDITIONAL_BALANCE":
            type = Strings.paymentAdditionalBalance;
            break;
        case "REGISTRATION_FEE":
            type = Strings.paymentRegistrationFee;
            break;

        default:
            break;
    }

    return type;
};

export const getPaymentType = (payment: Types.PaymentDto) => {
    let paymentType = Strings.dash;

    if (payment.paymentMethod === "ONLINE" && payment.paymentImp && payment.paymentImp.cardName) {
        const stringQuota =
            payment.paymentImp.cardType === "0" ? (payment.paymentImp.cardQuota === 0 ? "/일시불" : `/${payment.paymentImp.cardQuota}개월`) : "/체크";
        paymentType = payment.paymentImp.cardName + stringQuota;
    } else if (payment.paymentMethod === "OFFLINE_CARD" && payment.paidDate) {
        paymentType = "신용카드";
    } else if (payment.paymentMethod === "OFFLINE_BANK" && payment.paidDate) {
        paymentType = "계좌이체";
    } else if (payment.paymentMethod === "OFFLINE_CASH" && payment.paidDate) {
        paymentType = "현금";
    }

    return paymentType;
};

export const TypeRentStatus = {
    DURING_PAYMENT: "결제중",
    RESERVED: "예약완료",
    CANCELED: "예약취소",
    IN_USE: "이용중",
    ARRIVED: "도착완료",
    COMPLETED: "반납완료",
    NO_SHOW: "노쇼",
};

export const getRentStatus = (rent: Types.RentDto) => {
    return TypeRentStatus[rent.rentStatus];
    // let status = TypeRentStatus.RESERVED;
    // if (rent.rentPayments && rent.rentPayments[0].paidDate) {
    //     status = TypeRentStatus.PAID;
    // }

    // if (rent.canceledDate) {
    //     status = TypeRentStatus.CANCELED;
    // }

    // if (rent.usedDate) {
    //     status = TypeRentStatus.IN_USE;
    // }

    // if (rent.returnDate) {
    //     status = TypeRentStatus.RETURNED;
    // }

    // return status;
};

export const convertCurrency = (price: number | undefined) => {
    if (price === undefined) return Strings.dash;
    return convertCurrencyKorean(price);
};

export const utilIsEmptyObj = (obj: Record<string, any>) => {
    for (const _key in obj) {
        return false;
    }
    return true;
};

export const convertRentPaymentType = (payment: Types.RentPaymentDto) => {
    let paymentType = Strings.dash;

    if (payment.rentPaymentType === undefined || payment.rentPaymentType === null) {
        return paymentType;
    }

    switch (payment.rentPaymentType) {
        case "RENT":
            paymentType = Strings.rent;
            break;

        case "PAID_ITEM":
            paymentType = Strings.additional_item;
            break;

        case "PENALTY":
        case "INSURANCE":
            paymentType = payment.rentPaymentItem?.rentPaymentCategory?.rentPaymentCategoryName
                ? payment.rentPaymentItem?.rentPaymentCategory?.rentPaymentCategoryName
                : Strings.dash;
            break;

        default:
            break;
    }

    return paymentType;
};

export const convertRentPaymentItem = (rent: Types.RentDto | undefined, payment: Types.RentPaymentDto) => {
    if (payment.rentPaymentType === "RENT") return Strings.dash;

    if (payment.rentPaymentType === "PENALTY" || payment.rentPaymentType === "PAID_ITEM") {
        return payment.rentPaymentItem?.rentPaymentItemName ? payment.rentPaymentItem?.rentPaymentItemName : Strings.dash;
    }

    if (payment.rentPaymentType === "INSURANCE") {
        return payment.rentPaymentItem?.rentPaymentItemName ? payment.rentPaymentItem?.rentPaymentItemName.substring(7) : Strings.dash;
    }

    return Strings.dash;
};

export const convertRentPaymentMethod = (payment: Types.RentPaymentDto) => {
    let paymentMethod = Strings.dash;

    if (payment.paymentMethod === undefined || payment.paymentMethod === null) {
        return paymentMethod;
    }
    switch (payment.paymentMethod) {
        case "ONLINE":
            paymentMethod = Strings.online;
            break;

        case "OFFLINE_CARD":
            paymentMethod = Strings.offline_card;
            break;

        case "OFFLINE_BANK":
            paymentMethod = Strings.offline_bank;
            break;

        case "OFFLINE_CASH":
            paymentMethod = Strings.offline_cash;
            break;

        default:
            break;
    }

    return paymentMethod;
};

export const EVENT_COLOR = ["#ff0000", "#00ff00", "#0000ff", "#ffff00", "#ff00ff", "#00ffff", "#880000", "#008800", "#000088", "#000000"];
export const getColorFromRentCar = (rentCar: Types.RentCarDto) => {
    return EVENT_COLOR[rentCar.car.carId % EVENT_COLOR.length];
};

export const readyToService = () => {
    Modal.info({
        title: "준비 중",
        content: "미구현된 기능입니다.",
        okText: "확인",
        onOk() {},
        centered: true,
    });
};

export const isPossibleCancel = (rent: Types.RentDto) => {
    if (rent.rentStatus === "RESERVED" || rent.rentStatus === "NO_SHOW") {
        return true;
    }
    return false;
    // const status = getRentStatus(rent);

    // if (status === TypeRentStatus.IN_USE || status === TypeRentStatus.RETURNED) {
    //     return false;
    // }

    // return true;
};

export const getPaidItemsString = (rent: Types.RentDto) => {
    let paidItemsString = "";

    rent.rentPaidItems.forEach((item) => (paidItemsString += item.rentPaidItemName + "\n"));

    if (paidItemsString.length === 0) paidItemsString = Strings.dash;

    return paidItemsString;
};

export type RentsByDate = {
    [key: string]: Array<Types.RentDto>;
};

export const convertRentByStartDate = (rents: Array<Types.RentDto>, isShowAdminReservation: boolean) => {
    const obj: RentsByDate = {};
    rents.forEach((rent) => {
        if (rent.rentStatus !== "CANCELED" && (isShowAdminReservation || rent.user.email !== "support@alpamotors.com")) {
            if (!obj[rent.startDate]) obj[rent.startDate] = [];
            obj[rent.startDate].push(rent);
        }
    });

    return obj;
};

export const convertRentByEndDate = (rents: Array<Types.RentDto>, isShowAdminReservation: boolean) => {
    const obj: RentsByDate = {};
    rents.forEach((rent) => {
        if (rent.rentStatus !== "CANCELED" && (isShowAdminReservation || rent.user.email !== "support@alpamotors.com")) {
            if (!obj[rent.endDate]) obj[rent.endDate] = [];
            obj[rent.endDate].push(rent);
        }
    });

    return obj;
};

export const getReservationPayment = (rentPayments: Types.RentPaymentDto[] | undefined | null) => {
    if (rentPayments !== null && rentPayments !== undefined && rentPayments.length > 0) {
        const reservations = rentPayments.filter((rent) => rent.rentPaymentType === "RENT");
        if (reservations.length > 0) return reservations[0];
    }

    return null;
};

export const getAllPaidPaymentAmount = (rentPayments: Types.RentPaymentDto[] | undefined | null) => {
    if (rentPayments !== null && rentPayments !== undefined && rentPayments.length > 0) {
        const paidPayments = rentPayments.filter((rent) => rent.paidDate !== null && rent.paidDate !== undefined);
        let totalAmount = 0;
        paidPayments.forEach((payment) => (totalAmount += payment.amount - (payment.paymentImp?.cancelAmount || 0)));
        return totalAmount;
    }

    return 0;
};

export const getPaymentItemAmount = (rent: Types.RentDto, paymentItem: Types.RentPaymentItemDto) => {
    if (paymentItem.amount !== 0) return paymentItem.amount;

    const endDayOfWeek = moment(rent?.endDate).weekday();
    const penaltyAmount =
        endDayOfWeek === 5 || endDayOfWeek === 6
            ? rent?.rentCar.weekendDiscountPrice
                ? rent?.rentCar.weekendDiscountPrice
                : rent?.rentCar.weekendPrice
            : rent?.rentCar.discountPrice
            ? rent?.rentCar.discountPrice
            : rent?.rentCar.price;

    if (penaltyAmount === undefined) return 0;

    if (paymentItem.memo === "반납일 정상가 요금 100%") {
        return penaltyAmount;
    } else if (paymentItem.memo === "반납일 정상가 요금 200%") {
        return penaltyAmount * 2;
    }
    return 0;
};

export const isPaidByPaymentType = (paymentType: string, payments?: Array<Types.PaymentDto>) => {
    let isPaid = false;

    if (payments !== undefined && payments.length > 0) {
        const filterValues = payments.filter((payment) => payment.paymentType === paymentType);
        if (filterValues.length > 0 && filterValues[0].paidDate && filterValues[0].canceledDate === null && filterValues[0].failedDate === null) isPaid = true;
    }

    return isPaid;
};

export const getPaymentByPaymentType = (paymentType: string, payments?: Array<Types.PaymentDto>) => {
    let payment = null;

    if (payments !== undefined && payments.length > 0) {
        const filterValues = payments.filter((payment) => payment.paymentType === paymentType);
        if (filterValues.length > 0) payment = filterValues[0];
    }

    return payment;
};

export const to2Digit = (number: number) => {
    return ("0" + number.toFixed(0)).slice(-2);
};

export const validateEmail = (isFullType: boolean, hasRequired: boolean, value: string) => {
    const emailPattern = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/;
    const localPart = value.split("@")[0] || "";
    const domainPart = value.split("@")[1] || "";

    if (!value || !emailPattern.test(value) || localPart.length === 0 || domainPart.length === 0) {
        if (!hasRequired || value) {
            return Promise.reject(new Error("이메일을 입력해 주세요."));
        }
    }

    const localPartPattern = /^(?!\.)(?!.*\.\.)(?!.*\.$)[a-z0-9!#$%&'*+/=?^_`{}|~.-]+$/i;
    const domainPartPattern = /^(|[a-z0-9]([a-z0-9.-]*[a-z0-9])?)$/i;

    if (!localPartPattern.test(localPart) || !domainPartPattern.test(domainPart) || value.includes("..") || value.startsWith(".") || value.endsWith(".")) {
        return Promise.reject(new Error("영문자, 숫자 및 일부 특수문자만 입력 가능합니다."));
    }

    if (!isFullType) {
        if (localPart.length > 64) {
            return Promise.reject(new Error("@ 앞 아이디 부분은 최대 64자까지 입력할 수 있습니다."));
        }

        if (domainPart.length > 190) {
            return Promise.reject(new Error("@ 이후 도메인 값은 최대 190자까지 입력할 수 있습니다."));
        }
    }

    if (value.length > 320) {
        return Promise.reject(new Error("최대 320자까지 입력할 수 있습니다."));
    }

    return Promise.resolve();
};
